import styled from 'styled-components';

export const Container = styled.div`
  margin: 10px 0;
  padding: 10px;
  border-radius: 5px;
  background-color: #e7f1fe;
  border: 1px solid #b8d4f1;
  text-align: center;
`;

export const TableTitle = styled.div`
  margin-bottom: 10px;
  font-weight: bold;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`;

export const Th = styled.th`
  border: 1px solid #b8d4f1;
  padding: 8px;
  font-weight: bold;
  background-color: #e7f1fe;
`;

export const Td = styled.td`
  border: 1px solid #b8d4f1;
  padding: 8px;
  text-align: center;
`;
